import { PencilSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { CorporatePartHelper } from 'corporate/helpers';
import { useIsCorporatePartEditable } from 'corporate/hooks';
import { ICorporatePart } from 'corporate/types';

import { CorporatePartUpsert } from './CorporatePartUpsert';

interface IProps {
  corporatePart?: Partial<ICorporatePart> | null;
  partNumber: string;
  manufacturerId: number;
}

export const CorporatePartUpsertButton = ({
  corporatePart,
  partNumber,
  manufacturerId,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const isEditable = useIsCorporatePartEditable(corporatePart);
  const isSetUp = CorporatePartHelper.isSetUp(corporatePart);

  if (!isEditable) {
    return null;
  }

  return (
    <>
      <Button
        startDecorator={<PencilSimple />}
        text={isSetUp ? t('buttonLabelEdit') : t('buttonLabelSetUpPart')}
        onClick={() => setIsOpen(true)}
      />

      <CorporatePartUpsert
        corporatePart={corporatePart}
        partNumber={partNumber}
        manufacturerId={manufacturerId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
